import { motion } from "framer-motion";
import Image from '../../assets/Feedback/clgImage.jpg'
import { useState } from "react";
import SidebarGalleryPage from "../Main/Sidebargallery";


const About = () => {
  
  const [subject, setSubject] = useState('')
  const [branch, setBranch] = useState('')
  const [session, setSession] = useState('2021-22')
  const [rollNoAndName, setRollNoAndName] = useState('')
  const [comment, setComment] = useState('')

  return (
    <div className="min-h-screen bg-white p-12">
      {/* Main Content */}
      <div className="flex flex-col lg:flex-row gap-10">
      <div className="md:col-span-2">
          <img
            src={Image}
            alt="कॉलेज भवन"
            width={800}
            height={300}
            className="w-full h-auto border-4 border-[#00BFA5] rounded-lg p-2 mb-10"
          />
      
            <div className="max-w-3xl mx-auto font-sans">
            <div className="p-2 border-4 border-teal-500 rounded-lg">
                <h1 className="text-xl text-white rounded-sm bg-teal-500 font-bold p-2 mb-4">महिला शिकायत निवारण प्रकोष्ठ</h1>
                    <p className="p-2">
                      लड़कियों, महिलाओं या किसी भी कर्मचारी को सुरक्षा और सुरक्षा बनाए रखने के लिए, शिकायतों के निवारण के
                      लिए एक सेल गठित किया गया है। हमारी शिकायत निवारण प्रणाली (जीआरएस) सेल छात्रों और कर्मचारियों के
                      बीच किसी भी यौन उत्पीड़न, अवांछनीय गतिविधियों जैसे किसी भी प्रकार के कदाचार को रोकने के लिए हर
                      समय सतर्क रहती है। यदि छात्रा / कार्यकर्ता / कर्मचारियों को किसी भी उत्पीड़न का सामना करना पड़ता है, तो
                      वे शिकायत कक्ष के लिए शिकायत कर सकते हैं (जीआरएस)। समिति के सदस्य मुद्दों को देखेंगे और सभी
                      संबंधित सबूत इकट्ठा करेंगे, और दोषी के खिलाफ आवश्यक कदम उठाएंगे। हम इस प्रकार उत्पीड़न रोकने के
                      लिए भी, बाद में किए गए कार्यों और शिकायतों का निपटारा करने के लिए ध्यान केंद्रित करते हैं।
                    </p>
                    <div className="p-2">
                      <h2 className="mb-2 text-xl font-semibold text-gray-800">जीआरएस सेल में:</h2>
                      <p className="mb-2">संगीता सोनी (सीनियर लेक्चरर, फैशन टेक्नोलॉजी)-प्रभारक और अन्य तीन समिति के सदस्य</p>
                      <ol className="list-decimal list-inside">
                        <li>श्री रवीन्द्र के राजपूत (व्याख्याता, सीएसई),</li>
                        <li>श्रीमती अंकांक्षा गुप्ता (व्याख्याता, ईसी) और</li>
                        <li>श्रीमती कविता गुप्ता (फैशन प्रौद्योगिकी)</li>
                      </ol>
                    </div>
                  </div>
                  <div className="p-4 border-4 border-teal-500 rounded-lg mt-10">
                    <h2 className="text-xl text-black font-bold mb-4">
                      In order to maintain safety and security to the girls and women, a cell has been constituted for redressal of grievances.
                    </h2>
                    <p className="mb-4">
                      Our women grievance cell stays alert all the time to prevent any sexual abuse towards the students and female workers. If the students face any harassment from the staff or workers, then they can complain at our women grievance cell. The members will look into the issues, gather the evidence, and take the necessary action against the guilty. We also focus on preventing this kind of harassment by using secret monitory services, which keep a keen eye on the entire campus.
                    </p>
                    <p className="mb-4">HODs or Principal regularly attend to these problems.</p>
                    <p className="mb-4">
                      In addition, there is a Complaint cum Redressal Committee, which resolves the grievances of the students on the campus.
                    </p>
                    <p className="mb-4">
                      This cell is meant for maintaining the records of grievances, actions taken thereon and settlement of grievances. The cell is headed by the Principal, consisting of administrative officer and six lady faculty members. The grievance box is placed in the girl&apos;s waiting rooms where students have to drop their grievances, if any. The box is opened once in a month and checked. Any grievance found in it is scrutinized and necessary actions are immediately taken by the Cell. In case of emergency, the Principal calls a meeting and addresses the problems immediately. During the last two years the cell is is resolving the difficulties of the girl students &apos;grievances. It was settled amicably.
                    </p>
                  </div>
            </div>
      </div>
        
       {/* gallery */}
     <SidebarGalleryPage></SidebarGalleryPage>
      </div>
    </div>
  );
};

export default About;
